const download = (href: string) => {
  const aElement = document.createElement("a");
  aElement.href = href;
  aElement.download = "";
  aElement.click();
};

export default download;
